import React, { useEffect, useMemo, useState } from 'react';
import '../styles/Odometer.css';
interface OdometerProps {
    value: number;
    currency?: string; // e.g., "$"
    duration?: number;
}

export const Odometer: React.FC<OdometerProps> = ({
                                                      value,
                                                      currency = '€',
                                                      duration = 300,
                                                  }) => {
    const [chars, setChars] = useState<string[]>([]);

    useEffect(() => {
        const formatted = new Intl.NumberFormat('en-US').format(value);
        setChars(formatted.split(''));
    }, [value]);

    const renderedChars = useMemo(() => {
        return chars.map((char, i) => {
            if (/\d/.test(char)) {
                const digit = parseInt(char);
                return (
                    <div className="digit-container" key={i}>
                        <div
                            className="digit-strip"
                            style={{
                                transform: `translateY(-${digit * 10}%)`,
                                transition: `transform ${duration}ms ease-in-out`,
                            }}
                        >
                            {Array.from({ length: 10 }, (_, j) => (
                                <div className="digit" key={j}>
                                    {j}
                                </div>
                            ))}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className="separator" key={i}>
                        {char}
                    </div>
                );
            }
        });
    }, [chars, duration]);

    return (
        <div className="odometer">
            <span className="currency">{currency}</span>
            {renderedChars}
        </div>
    );
};
export default Odometer;
